import React from 'react';
import { Box, CardContent, Typography, useTheme } from '@mui/material';

export const ChannelDetail = (props: {
  title: string;
  value: string;
  unit?: string;
  onClick?: () => void;
}) => {
  const { title, value, unit, onClick } = props;
  const theme = useTheme();
  return (
    <CardContent
      onClick={onClick}
      sx={{
        borderRadius: '2rem',
        backgroundColor: theme.palette.background.paper,
        height: '100%',
        padding: '2rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: onClick ? 'pointer' : 'default',
        gap: '1rem',
        '&:last-child': {
          paddingBottom: '2rem',
        },
      }}
    >
      <Typography
        variant="caption"
        lineHeight={'1rem'}
        color="text.secondary"
        textAlign={'center'}
        justifySelf={'start'}
      >
        {title}
      </Typography>
      <Box display="flex" flexDirection="row" alignItems="flex-start">
        <Typography fontSize={'3.5rem'} color="text.primary">
          {value}
        </Typography>
        <Typography fontSize={'2rem'} color="text.primary" lineHeight={'1.95'}>
          {unit}
        </Typography>
      </Box>
    </CardContent>
  );
};
